export default "__VITE_ASSET__D3i94aRb__"